import { render } from "./userSMSLogin.vue?vue&type=template&id=55e2cb10&scoped=true&enter-active-class=animate__animated%20animate__fadeInDown&leave-active-class=animate__animated%20animate__fadeOutUp"
import script from "./userSMSLogin.vue?vue&type=script&lang=js"
export * from "./userSMSLogin.vue?vue&type=script&lang=js"

import "./userSMSLogin.vue?vue&type=style&index=0&id=55e2cb10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e2cb10"]])

export default __exports__